import React from "react";
import { cn } from "../../../utils/util";
import styles from "./button.module.css";

/**
 * Reusable Button component with primary and default variants
 */
const Button = ({
  children,
  variant = "default",
  size = "md",
  icon,
  iconPosition = "left",
  className,
  disabled = false,
  fullWidth = false,
  type = "button",
  onClick,
  ariaLabel,
  style,
  textColor,
  ...props
}) => {
  return (
    <button
      type={type}
      className={cn(
        styles.button,
        styles[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        icon && !children && styles.iconOnly,
        className
      )}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel || (typeof children === 'string' ? children : undefined)}
      style={{
        ...style,
        color: textColor
      }}
      {...props}
    >
      {icon && iconPosition === "left" && (
        <span className={styles.iconLeft}>{icon}</span>
      )}
      
      {children && <span className={styles.label}>{children}</span>}
      
      {icon && iconPosition === "right" && (
        <span className={styles.iconRight}>{icon}</span>
      )}
    </button>
  );
};

export default Button;